import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import TicketType from 'src/app/core/models/ticket.type';

export type SeatItem = {
  block: string;
  seat: string;
  price: number;
};

export type BlockTicketType = TicketType & {
  color: string;
  map_id: string;
  group: string;
};

export type LegendItem = { price: string; name: string; color: string };

@Component({
  selector: 'ticket-types-legend',
  standalone: true,
  templateUrl: './ticket-types-legend.component.html',
  styleUrls: ['./ticket-types-legend.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
})
export class TicketTypesLegendComponent implements OnChanges {
  @Input() ticketTypes: Array<BlockTicketType> = [];
  @Input() expanded = false;
  @Output() onClose = new EventEmitter();
  @Output() onOpen = new EventEmitter();

  items: LegendItem[] = [];

  get isSmallDevice() {
    return window.innerWidth > 1500;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['ticketTypes']) {
      return;
    }

    this.ticketTypes.forEach((tt) => {
      if (!tt.group) {
        return;
      }

      if (!this.items.find((item) => item.name === tt.group)) {
        this.items.push({
          name: tt.group,
          price: tt.price.toLocaleString(),
          color: tt.color,
        });
      }
    });
  }

  price(tt: TicketType) {
    return `RD$${tt.price.toLocaleString()}`;
  }

  onExpandToggle() {
    if (this.expanded) {
      this.onClose.emit();
    } else {
      this.onOpen.emit();
    }

    this.expanded = !this.expanded;
  }
}
